<template>
  <nav id="menu">
    <div class="inner">
      <h2>Menu</h2>
      <ul class="links">
        <li>
          <router-link :to="{ name: 'home' }" @click="hideMenu">Home</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'sponsors' }" @click="hideMenu">Sponsor</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'players' }" @click="hideMenu">Rosa calciatori</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'staff' }" @click="hideMenu">Organico</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ranking' }" @click="hideMenu">Classifica</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'gallery' }" @click="hideMenu">Gallery</router-link>
        </li>
      </ul>
      <a class="close" @click="hideMenu">Close</a>
    </div>
  </nav>
</template>

<script setup lang="ts">
function hideMenu() {
  document.getElementById('body')?.classList.remove('is-menu-visible');
}
</script>
